<template>
  <div :class="s.container">
    <div :class="s.kumo_wrap">
      <div :class="s.header">
        <img :class="s.header_title" src="/img/pages/choikulove/thanks/kv.png" alt="">
      </div>
      <div :class="s.content">
        <div :class="s.content_bg"></div>
        <div :class="s.content_kumo_wrap">
          <div :class="s.content_kumo_inner">
            <img :class="s.kumo_comment" src="/img/pages/choikulove/thanks/kumo-top.svg" alt="">
            <img :class="s.xlogo" src="/img/pages/choikulove/thanks/x-logo.svg" alt="">
            <div :class="s.follow_btn">
              <a :class="s.follow_btn_img" href="https://x.com/seeboncho">
                <img src="/img/pages/choikulove/thanks/follow-btn.svg" alt="フォローする">
              </a>
            </div>
          </div>
          <div :class="[s.content_kumo, s.pink_kumo]"></div>
        </div>

        <div :class="s.content_kumo_wrap">
          <div :class="s.content_kumo_inner">
            <div :class="s.blue_kumo_item_title">応募規約</div>
            <div :class="s.blue_kumo_item_box">
              <img :class="s.blue_kumo_item_box_bg" src="/img/pages/choikulove/specialcampaign/gizagiza.svg" alt="">
              <div ref="termsButton" :class="s.blue_kumo_item_btn" @click.stop="triggerTermsClicked">
                <div :class="s.blue_kumo_item_btn_img">
                  <img src="/img/pages/choikulove/specialcampaign/btn-accordion.svg" alt="くわしくはコチラ">
                </div>
              </div>
              <div
                id="terms-accordion-content"
                :class="[s.terms_accordion, flag.showTerms ? s.show : '']">
                <div :style="`max-height: ${accordionMaxH}px;`">
                  <div :class="s.terms_accordion_content">{{ termsText }}</div>
                </div>
              </div>
            </div>
          </div>
          <div :class="[s.content_kumo, s.blue_kumo]"></div>
        </div>
        <div :class="[s.content_kumo_wrap, flag.showTerms && s.green]">
          <div :class="s.content_kumo_inner">
            <a href="/" :class="s.green_kumo_item_btn_img">
              <img src="/img/pages/choikulove/thanks/return-btn.svg" alt="TOPへ戻る">
            </a>
          </div>
          <div :class="[s.content_kumo, s.green_kumo]"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnqueteThanks',
  data() {
    return {
      flag: {
        showTerms: false,
      },
      accordionMaxH: 0,
      clickOutsideListener: null,
      termsText: `[運営事務局]
本キャンペーンは「一般社団法人投資信託協会」が主催し、キャンペーン事務局が運営しております。なお、適正な運用を行う為に事務局が必要と判断した場合に限り、本キャンペーンの応募条件変更等、あらゆる対応を取ることができるものとさせていただきます。あらかじめご了承ください。詳しくはその他の注意事項をご確認ください。
[キャンペーン名]
ちょいくプロジェクト "CHOIKULOVE"キャンペーン
[商品]
A 賞 シーボンチャーム＋... T シャツ＋トートバッグセット...5 名
B 賞 シーボンチャーム＋... T シャツセット...15 名
C 賞 シーボンチャーム... ...50 名
※T シャツ・トートバッグはそれぞれ複数のデザインをご用意しており、お届けする商品は
ランダムとなります。デザインのご指定はできませんので、あらかじめご了承ください。
本キャンペーン募集の内容および賞品は、予告なく変更される場合があります※
[応募期間]
2025 年12 月9 日（火）〜 12 月26 日（金）23:59 までのご応募
[当選人数]
合計70名様
[賞品発送]
賞品発送はキャンペーン応募期間終了後の1月中旬頃を予定しております。都合により賞品の発送が多少遅れる場合もございます。当選者の発表は、商品の発送をもって代えさせていただきます。当選者には公式X アカウントより、DM にてご連絡いたします。その際、賞品のお送り先をお伺いいたします。DM が開放されていないなど、こちらからコンタクトを取ることが不可能な場合は、当選無効とさせていただきます。
[その他の注意事項]
本キャンペーンについては下記をお読みいただき、同意いただける場合のみご応募ください。
1. 本キャンペーンに応募していただくにあたり、応募者はキャンペーンの運用について事務局の運用方法にしたがうものとし、一切異議申立てを行わないものとします。
2. 本キャンペーンの当選連絡および賞品発送に関する連絡に関して、事務局からご連絡をさせていただく場合がございます。
3. 本キャンペーンサイトの利用・利用停止・もしくは不能による損害について事務局は一切責任を負いかねます。（各種WEB サービスのサーバーダウンなども含む）
4. 本サイトの理由によるいかなるトラブル・損害（直接、間接の損害別を問わず）が発生したとしても一般社団法人投資信託協会は一切の責任を負いません。あらかじめご了承くだ
さい。
5. ご応募いただく際にお預かりする皆様の個人情報の保護方針については、一般社団法人投資信託協会ホームページ内の「プライバシーポリシー」及び「コミュニティガイドライン」に記載しております。必ずご一読の上、同意した上でご応募ください。なお、本キャンペーンにご応募された方は、本プライバシーポリシーに同意したものとみなします。
6. キャンペーンの応募状況及び抽選結果に関するお問い合わせにはお答えしかねますので、予めご了承ください。
7. ご応募は日本国内にお住まいの方に限らせていただきます。
8. 抽選で獲得された権利は他人に譲渡できません。転売等はお控えください。
9. 本キャンペーンはX 社とは一切関係ありません。お問い合わせに関しては、下記お問い合わせ先までご連絡ください。
[禁止事項]
応募を通じて、以下の事項に該当するアカウントからの応募は無効とさせていただく場合があります。
また当選後に判明した場合も、当選権利を無効とさせていただく場合があります。
・X の利用規約に違反している。
・自動プログラムを利用しての応募。
・複数のX アカウントからの応募。
・代理応募。（親族の代理応募も禁止となります）
・本キャンペーンの運営を妨げる行為。
・特定の団体や個人に対する誹謗中傷。
・公序良俗に反する行為。
・宣伝及び勧誘行為。
・その他、運営事務局が不適切だと判断した行為。
[賠償責任]
本サイトの利用に関連して利用者と第三者との間に紛争が発生した場合には、利用者は、自身の責任と費用で当該紛争を解決するものとし、一般社団法人投資信託協会に損害を与えることのないようにするものとします。
[準拠法および裁判管轄]
本キャンペーン規約の解釈・適用に関しましては、日本国法に準拠するものといたします。
[お問い合わせ]
このキャンペーンに関するお問い合わせは下記までDM でお願いいたします。
ちょいくプロジェクト公式X アカウント（＠seeboncho）
受付時間　9:00～17:00（土・日・祝日を除く）`,
    };
  },
  methods: {
    triggerTermsClicked() {
      this.flag.showTerms = !this.flag.showTerms;
      if (this.flag.showTerms) {
        const winH = window.innerHeight;
        const accordionElem = document.getElementById('terms-accordion-content');
        const elemPos = accordionElem?.getBoundingClientRect().top;
        if (!accordionElem || !winH) return;
        const bottomLen = winH - elemPos;
        this.accordionMaxH = bottomLen - 320;
      }
    },
    handleClickOutside(event) {
      const accordionContent = document.getElementById('terms-accordion-content');
      const termsButton = this.$refs.termsButton;

      // ボタンクリックは無視（triggerTermsClickedが処理するため）
      if (termsButton && termsButton.contains(event.target)) return;

      // アコーディオン内部のクリックは無視
      if (accordionContent && accordionContent.contains(event.target)) return;

      // 外側クリック → 閉じる
      this.flag.showTerms = false;
    },
  },
  watch: {
    'flag.showTerms': function (newVal) {
      if (newVal) {
        // 開いたら次のティックでリスナー追加
        this.$nextTick(() => {
          this.clickOutsideListener = this.handleClickOutside.bind(this);
          document.addEventListener('click', this.clickOutsideListener);
        });
      } else if (this.clickOutsideListener) {
        // 閉じたらリスナー削除
        document.removeEventListener('click', this.clickOutsideListener);
        this.clickOutsideListener = null;
      }
    },
  },
  beforeUnmount() {
    // コンポーネント破棄時にリスナーをクリーンアップ
    if (this.clickOutsideListener) {
      document.removeEventListener('click', this.clickOutsideListener);
    }
  },
};
</script>

<style lang="scss" module="s">
.container {
  padding-top: 75px;
  background-color: var(--primary-yellow);
  padding-bottom: 600px;

  @include mdView {
    padding-top: 40px;
    padding-bottom: 250px;
  }

  @include smView {
    padding-top: 30px;
    padding-bottom: 200px;
  }
}

.kumo_wrap {
  position: relative;
  padding-top: 0;
  padding-bottom: 300px;
  background-color: #ffd2bf;
  text-align: center;
  z-index: 25;

  @include mdView {
    padding-bottom: 150px;
  }

  @include smView {
    padding-bottom: 50px;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    display: block;
    width: 100vw;
    height: 56px;
    background-image: url(/img/pages/choikulove/specialcontent/bg-pattern.svg);
    background-color: var(--primary-yellow);
    background-repeat: repeat-x;
    background-size: contain;
    background-position: center 0;

    @include mdView {
      height: 40px;
    }

    @include smView {
      height: 25px;
    }
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
    rotate: 180deg;
  }
}

.header {
  position: relative;
  width: 90%;
  margin: 0 auto;

  @include mdView {
    width: 100%;
  }

  @include smView {
    overflow: hidden;
  }
}

.header_title {
  position: relative;
  width: 100%;
  z-index: 3;
  translate: 0 -2vw;

  @include smView {
    width: 160vw;
    translate: -30vw 0;
  }
}

.content {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;
}

.content_bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(/img/pages/choikulove/thanks/bottom-stars.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  z-index: 2;
}

.content_kumo_wrap {
  position: relative;
  width: 100%;
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.green {
    z-index: 1;
  }

  @include mdView {
    height: calc(320px * 40 / 56);
  }

  @include smView {
    height: calc(320px * 25 / 56);
  }
}

.content_kumo {
  position: absolute;
  width: 100%;
  background-color: var(--primary-pink);
  z-index: 1;
  height: 100%;
  top: 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    display: block;
    width: 100vw;
    height: 56px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 107 56'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bclip-path:url(%23clippath);%7D.cls-2%7Bfill:none;stroke-width:0px;%7D.cls-3%7Bfill:%23f087aa;stroke:%23000;stroke-miterlimit:10;stroke-width:2.83px;%7D%3C/style%3E%3CclipPath id='clippath'%3E%3Crect class='cls-2' width='107' height='56'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg class='cls-1'%3E%3Cpath class='cls-3' d='M154.1,177.63c1.55-8.66,3.75-17.19,4.44-25.97,1.34-17.03-.59-34.08-.91-51.12-.61-32.8-.2-65.66-.08-98.48-28.19,1.53-50.58,24.88-50.58,53.45C106.98,25.95,83.01,1.98,53.44,1.98S-.1,25.95-.1,55.51C-.1,25.95-24.07,1.98-53.64,1.98h0c-29.57,0-53.54,23.97-53.54,53.54v141.92H151.11c.81-6.63,1.82-13.23,2.99-19.8Z'/%3E%3C/g%3E%3C/svg%3E");
    background-repeat: repeat-x;
    background-size: contain;
    background-position: center 0;
    background-color: #ffd2bf;

    @include mdView {
      height: 40px;
    }

    @include smView {
      height: 25px;
    }
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
    rotate: 180deg;
  }
}

.blue_kumo {
  background-color: #55ABFF;

  &::before,
  &::after {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 107 56'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bclip-path:url(%23clippath);%7D.cls-2%7Bfill:none;stroke-width:0px;%7D.cls-3%7Bfill:%2355ABFF;stroke:%23000;stroke-miterlimit:10;stroke-width:2.83px;%7D%3C/style%3E%3CclipPath id='clippath'%3E%3Crect class='cls-2' width='107' height='56'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg class='cls-1'%3E%3Cpath class='cls-3' d='M154.1,177.63c1.55-8.66,3.75-17.19,4.44-25.97,1.34-17.03-.59-34.08-.91-51.12-.61-32.8-.2-65.66-.08-98.48-28.19,1.53-50.58,24.88-50.58,53.45C106.98,25.95,83.01,1.98,53.44,1.98S-.1,25.95-.1,55.51C-.1,25.95-24.07,1.98-53.64,1.98h0c-29.57,0-53.54,23.97-53.54,53.54v141.92H151.11c.81-6.63,1.82-13.23,2.99-19.8Z'/%3E%3C/g%3E%3C/svg%3E");
  }
}

.green_kumo {
  background-color: #55B96E;

  &::before,
  &::after {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 107 56'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bclip-path:url(%23clippath);%7D.cls-2%7Bfill:none;stroke-width:0px;%7D.cls-3%7Bfill:%2355B96E;stroke:%23000;stroke-miterlimit:10;stroke-width:2.83px;%7D%3C/style%3E%3CclipPath id='clippath'%3E%3Crect class='cls-2' width='107' height='56'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg class='cls-1'%3E%3Cpath class='cls-3' d='M154.1,177.63c1.55-8.66,3.75-17.19,4.44-25.97,1.34-17.03-.59-34.08-.91-51.12-.61-32.8-.2-65.66-.08-98.48-28.19,1.53-50.58,24.88-50.58,53.45C106.98,25.95,83.01,1.98,53.44,1.98S-.1,25.95-.1,55.51C-.1,25.95-24.07,1.98-53.64,1.98h0c-29.57,0-53.54,23.97-53.54,53.54v141.92H151.11c.81-6.63,1.82-13.23,2.99-19.8Z'/%3E%3C/g%3E%3C/svg%3E");
  }
}

.content_kumo_inner {
  position: relative;
  width: calc(100% - 20%);
  max-width: 1052px;
  margin: 0 auto;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.kumo_comment {
  position: relative;
  width: 100%;
  max-width: 1052px;
  z-index: 2;
  margin-top: -6%;

  @include smView {
    margin-top: -20%;
  }
}

.xlogo {
  position: relative;
  width: 100%;
  max-width: 156px;
  z-index: 2;
  margin-top: -6%;

  @include mdView {
    width: 11vw;
  }

  @include smView {
    margin-top: -5%;
    width: 15vw;
  }
}

.follow_btn {
  position: relative;
  z-index: 3;
  margin-top: -3.5%;
}

.follow_btn_img {
  position: relative;
  width: 25vw;
  min-width: 100px;
  display: block;

  @include smView {
    width: 30vw;
  }

  img {
    position: relative;
    display: block;
    z-index: 2;
    transition: transform 300ms;
    transform: translate(-0.4vw, -0.4vw);
  }

  &:hover {
    img {
      transform: translate(.4vw, .4vw);
    }
  }

  &::before {
    position: absolute;
    width: 25vw;
    min-width: 100px;
    z-index: 1;
    content: "";
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(calc(-50% + 0.4vw), calc(-50% + 0.4vw));
    background-image: url(/img/pages/choikulove/thanks/follow-btn-bg.svg);
    transition: all 0.3s;
    background-repeat: no-repeat;

    @include smView {
      width: 30vw;
    }
  }
}

.blue_kumo_inner {
  position: relative;
  width: calc(100% - 20%);
  max-width: 1052px;
  margin: 0 auto;
  z-index: 2;
  top: 8%;
}

.blue_kumo_item_title {
  font-size: 42px;
  font-weight: 700;
  position: relative;
  z-index: 5;
  background-color: var(--primary-pink);
  border: 1px solid var(--primary-black);
  border-radius: 100px;
  max-width: 330px;
  width: 20vw;
  padding: 16px 0;
  margin: 0 auto;
  margin-bottom: -4%;

  @include mdView {
    font-size: 25px;
  }

  @include smView {
    font-size: 16px;
    padding: 7px 0;
    min-width: 100px;
  }
}

.blue_kumo_item_box {
  position: relative;
  z-index: 4;
  background-image: url('/img/pages/choikulove/specialcampaign/q-white-kumo-2.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 5%;
  width: 100%;
  max-width: 1052px;
  padding-block: 6.5%;
  height: 100%;
  margin: 0 auto;

  @include smView {
    background-size: 100% 100%;
    aspect-ratio: auto;
    padding: 6% 2%;
    gap: 10px;
  }
}

.blue_kumo_item_box_bg {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 100%;
  object-fit: contain;
}

.blue_kumo_item_btn {
  position: relative;
  z-index: 2;
}

.blue_kumo_item_btn_img {
  position: relative;
  width: 25vw;
  min-width: 100px;
  max-width: 300px;
  margin: 0 auto;

  img {
    position: relative;
    display: block;
    z-index: 2;
    transition: transform 300ms;
    transform: translate(-0.4vw, -0.4vw);
  }

  &:hover {
    img {
      transform: translate(.4vw, .4vw);
    }
  }

  &::before {
    position: absolute;
    width: 25vw;
    min-width: 100px;
    max-width: 300px;
    z-index: 1;
    content: "";
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(calc(-50% + 0.4vw), calc(-50% + 0.4vw));
    background-image: url(/img/pages/choikulove/specialcampaign/btn-accordion_bg.svg);
    transition: all 0.3s;
    background-repeat: no-repeat;
  }
}

.green_kumo_item_btn {
  position: relative;
  z-index: 2;
}

.green_kumo_item_btn_img {
  position: relative;
  width: 25vw;
  min-width: 100px;
  max-width: 370px;
  margin: 0 auto;

  img {
    position: relative;
    display: block;
    z-index: 2;
    transition: transform 300ms;
    transform: translate(-0.4vw, -0.4vw);
  }

  &:hover {
    img {
      transform: translate(.4vw, .4vw);
    }
  }

  &::before {
    position: absolute;
    width: 25vw;
    min-width: 100px;
    max-width: 370px;
    z-index: 1;
    content: "";
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(calc(-50% + 0.4vw), calc(-50% + 0.4vw));
    background-image: url(/img/pages/choikulove/thanks/return-btn-bg.svg);
    transition: all 0.3s;
    background-repeat: no-repeat;
  }
}

/* 応募規約アコーディオンのスタイル */
.terms_accordion {
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: var(--primary-white);
  width: 80%;
  margin: 0 auto;
  font-weight: 600;
  transform-origin: top;
  transform: translateX(-50%);
  max-height: 0;
  text-align: left;
  z-index: 0;

  > * {
    height: 100vh;
    overflow: scroll;
    width: 100%;
    padding: 40px;
    background-color: var(--primary-white);
    border: 1px solid var(--primary-black);
    border-top: none;
    transition: all .3s;
    transform-origin: top;
    transform: scaleY(0) translateY(0);
    border-radius: 0 0 15px 15px;

    @include smView {
      padding: 20px;
    }
  }

  &.show {
    > * {
      transform: scaleY(100%) translateY(0);
    }
  }
}

.terms_accordion_content {
  z-index: 3;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  font-weight: 600;

  @include smView {
    font-size: 12px;
  }
}
</style>
